import gql from 'graphql-tag';

export const VENUE_QUERY = gql`
  query getAllVenues($companyId: ID!) {
    items: allVenues(filter: { deleted: false, company: { id: $companyId } }) {
      id
      name
      location {
        id
        name
      }
    }
  }
`;

export const SAVE_MUTATION = gql`
  mutation SaveFieldMutation($data: SubmitIntegrationFormFieldData!) {
    submitIntegrationFormField(data: $data) {
      success
      message
    }
  }
`;
